<template>
  <v-layout>
    <v-dialog v-model="dialog" width="550" persistent>
      <v-card>
        <v-card-title ss="headline grey lighten-2" primary-title>
          Selecione o Fornecedor da Cotação
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selects.fornecedores.value"
            :items="selects.fornecedores.items"
            label="Selecione o Fornecedor Padrão dessa Cotação"
            item-value="idfornecedor"
            item-text="razao_social"
            outlined
            chips
            height="10"
            class="mt-5"
            :error-messages="fornecedorErrors"
            @input="$v.selects.fornecedores.value.$touch()"
            @blur="$v.selects.fornecedores.value.$touch()"
          ></v-autocomplete>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" text @click="fechar">CANCELAR</v-btn>
          <v-btn color="primary" text @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import CarrinhoAPI from "./../../../api/carrinho";
import { required } from "vuelidate/lib/validators";

export default {
  props: ["dialog", "pedidoSelecionado", "cadastrarFornecedorPadrao"],

  data: () => ({
    selects: {
      fornecedores: {
        items: [],
        value: "",
      },
    },
  }),

  validations: {
    selects: {
      fornecedores: {
        value: {
          required,
        },
      },
    },
  },

  computed: {
    ...mapGetters({
      fornecedor: "fornecedor/getFornecedor",
    }),
    fornecedorErrors() {
      const errors = [];
      if (!this.$v.selects.fornecedores.value.$dirty) return errors;
      !this.$v.selects.fornecedores.value.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.buscarFornecedores();
        this.selects.fornecedores.value = '';
      }
    },
    fornecedor: function () {
      this.selects.fornecedores.items = [];
    },
    cadastrarFornecedorPadrao: function () {
      this.selects.fornecedores.value = this.cadastrarFornecedorPadrao.fornecedor;
      this.salvar(false);
    },
  },

  methods: {
    fechar: function () {
      this.selects.fornecedores.value = "";
      this.$emit("fechar");
    },

    salvar: function (fechar = true) {
      this.$v.$touch();

      if (this.selects.fornecedores.value > 0) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          idpedido: this.pedidoSelecionado.idpedido,
          idfornecedor: this.selects.fornecedores.value,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CarrinhoAPI.setFornecedorCotacaoCissPoder(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (fechar) {
                this.fechar();
                this.$v.$reset();
                this.$emit("salvou");

                if (this.pedidoSelecionado.execRelatorio) {
                  this.$emit("execRelatorio");
                }
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    buscarFornecedores: function () {
      if (!this.selects.fornecedores.items.length > 0) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          fabricante: this.fornecedor.id,
          analiseGrupoFornecedores: localStorage.analiseGrupoFornecedores
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CarrinhoAPI.getFornecedorFabricante(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                const fornecedores = response.data.forneFabri;

                fornecedores.forEach((forn) => {
                  this.selects.fornecedores.items.push({
                    idfornecedor: forn.idfornecedor,
                    razao_social: `${forn.cnpj} - ${forn.razao_social} (${forn.idfornecedor})`,
                  });
                });
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
  },
};
</script>
